










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { isEmpty, isNil } from 'lodash';
import { api } from '@/api';
import moment from 'moment';
import store from '@/store';
import { ExtendMixins, LoadingService } from '@/services';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import {
  dateTransactionFormat,
  dateFormat,
  datePickerFormat,
} from '@/constants';
import { EventBus } from '@/event-bus';
import { StepperWrapper } from '@/components/stepper-wrapper-component';
import { DatePicker } from '@/components/form-components';
import {
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import {
  required,
  requiredIf,
  numeric,
  maxLength,
} from 'vuelidate/lib/validators';
import { req } from 'vuelidate/lib/validators/common';
import { date, dateHelpers, exactLength, taxIdNumber } from '@/validations';
import { dialogMaxWidth, dateFormatYYYYMMDD } from '@/constants';
import { getContentArea } from '@/contentful';
import {
  FormValidation,
  OpenHelp,
  RouteTracking,
  CloseStepperWrapper,
  FileUpload,
  TriggerRefreshError,
  DateFormat,
} from '@/mixins';
import {
  OpenAddBankAccountScreen,
  OpenAddProviderScreen,
} from '@/mixins/get-content-mixins';
import { NumberEntry } from '@/components/number-entry-component';
import { AttachDocuments } from '@/components/my-documents-components/attach-documents-component';
import { FileUtils } from '@/helpers';
import { TokenReAuth } from '@/components/page-components';
import {
  MemberAccountResponseModel, MemberBankAccountResponseModel, MemberDependentResponseModel,
  MemberPersonalInformationResponseModel, MemberProvidersResponseModel,
  StepperSteps,
  SubmitClaimFormModel,
} from '@/@types/member';
import { SelectOption } from '@/@types/member/lib/forms';

interface Data {
  formModel: SubmitClaimFormModel;
  tokenModal: boolean;
  reimburseByCheck: boolean;
  guidelines: string;
  dcapUploadDocuments: any[];
  dcapAgreementTerms: any;
  currentStep: number;
  initialDocuments: any[];
  documentParam: any;
  selectedFiles: [];
  initAccountId: string;
  initProviderId: string;
  // TODO typings
  account: any;
  accountType: string;
  claimAction: string;
  getDataIsLoading: boolean;
  showProviderRequiredScreen: boolean;
  showGetProvidersErrorScreen: boolean;
  getProvidersErrorMessage: string;
  showProviderRequiredDialog: boolean;
  showBankAccountRequiredScreen: boolean;
  showGetBankAccountsErrorScreen: boolean;
  getBankAccountsErrorMessage: string;
  showReimburseByCheckDialog: boolean;
  showPossibleDuplicateClaimDialog: boolean;
  showMissingPatientNameDialog: boolean;
  isDuplicateOverride: boolean;
  distributionReasonOptions: SelectOption[];
  serviceTypes: SelectOption[];
  confirmBeforeClose: boolean;
  submitIsLoading: boolean;
  showSubmitSuccessMessage: boolean;
  submitGetReimbursedSuccessMessage: string;
  submitPayBillSuccessMessage: string;
  showSubmitErrorMessage: boolean;
  submitErrorMessage: string;
  encryptedPDFError: boolean;
  errorEncryptedPDFMessage: string;
  badFileError: boolean;
  errorBadFileMessage: string;
  dialogMaxWidth: string;
  dateTransactionFormat;
  duplicateClaim: any;
}

export default ExtendMixins(
  RouteTracking,
  FormValidation,
  OpenHelp,
  CloseStepperWrapper,
  FileUpload,
  OpenAddBankAccountScreen,
  OpenAddProviderScreen,
  TriggerRefreshError,
  DateFormat,
)
  .extend({
    name: 'SubmitClaim',
    beforeRouteEnter(to, from, next) {
      const promises = [
        store.dispatch('getAccounts'),
        store.dispatch('getPersonalInformation'),
        getContentArea([
          'submit-claim-success-get-reimbursed',
          'submit-claim-success-pay-bill',
          'submit-claim-error-encrypted-pdf',
          'submit-claim-error-bad-file',
          'submit-claim-error',
          'submit-claim-error-get-bank-accounts',
          'submit-claim-error-get-providers',
          'submit-claim-error-get-providers',
          'attach-documents-guidelines',
          'dcap-upload-documebnt',
        ]),
        store.dispatch('getVaultData'),
      ];
      LoadingService.watchPromises(promises)
        .then((data) => {
          // Set content;
          const contentAreas = data[2];
          if (contentAreas) {
            if (contentAreas[0] && contentAreas[0].fields) {
              to.meta.submitGetReimbursedSuccessMessage =
                contentAreas[0].fields.content;
            }
            if (contentAreas[1] && contentAreas[1].fields) {
              to.meta.submitPayBillSuccessMessage =
                contentAreas[1].fields.content;
            }
            if (contentAreas[2] && contentAreas[2].fields) {
              to.meta.errorEncryptedPDFMessage = contentAreas[2].fields.content;
            }
            if (contentAreas[3] && contentAreas[3].fields) {
              to.meta.errorBadFileMessage = contentAreas[3].fields.content;
            }
            if (contentAreas[5] && contentAreas[5].fields) {
              to.meta.submitErrorMessage = contentAreas[5].fields.content;
            }
            if (contentAreas[6] && contentAreas[6].fields) {
              to.meta.getBankAccountsErrorMessage =
                contentAreas[6].fields.content;
            }
            if (contentAreas[7] && contentAreas[7].fields) {
              to.meta.getProvidersErrorMessage = contentAreas[7].fields.content;
            }
            if (contentAreas[8] && contentAreas[8].fields) {
              to.meta.guidelines = contentAreas[8].fields.content;
            }
            if (contentAreas[9] && contentAreas[9].fields) {
              to.meta.dcapUploadDocuments = contentAreas[9].fields.helpContent;
            }
          }

          // Get accounts
          const activeAccounts = store.getters.accounts.filter((account) => {
            return account.isActive;
          });
          if (activeAccounts.length) {
            next();
          } else {
            EventBus.$emit('openModal', 'Error', {
              title: 'submit-claim_title_error_no-active-accounts',
              message: 'submit-claim_text_error_no-active-accounts',
            });
            EventBus.$emit('initialLoadDone');
            next({name: 'accounts'});
          }
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
            action: {
              label: 'global_try-again',
              performAction() {
                location.reload();
              },
            },
            hideCancel: true,
          });
          EventBus.$emit('initialLoadDone');
        });
    },
    data(): Data {
      return {
        formModel: {
          amount: this.$route.params.document
            // @ts-ignore
            ? this.$route.params.document.amount
            : 0,
          sendTo: '',
          payTo: '',
          serviceFromDate: '',
          serviceToDate: '',
          providerName: '',
          patientName: '',
          patientNameOther: '',
          termsAndConditionsSubmit: false,

          // HSA only
          noteToSelf: this.$route.params.document
            // @ts-ignore
            ? this.$route.params.document.noteToSelf
            : '',
          distributionReason: 'normal-distribution',
          termsAndConditionsHSA: false,

          // Medical only
          serviceType: '',

          // Dependent care only
          providerTaxID: null,
          dependentName: '',
          dependentNameOther: '',

          // Adoption only
          childName: '',

          // Premium reimbursement only
          insuranceCarrier: '',
          policyholderName: '',
          coverageType: '',
        },
        tokenModal: false,
        reimburseByCheck: false,
        guidelines: this.$route.meta.guidelines,
        dcapUploadDocuments: null,
        dcapAgreementTerms: null,
        currentStep: 1,
        initialDocuments: this.$route.params.document
          // @ts-ignore
          ? [this.$route.params.document.vaultId]
          : [],
        documentParam: this.$route.params.document,
        selectedFiles: [],
        initAccountId: this.$route.params.accountId,
        initProviderId: this.$route.params.providerId,
        account: '',
        accountType: '',
        claimAction: this.$route.params.action || 'reimburse',
        getDataIsLoading: false,
        showProviderRequiredScreen: false,
        showGetProvidersErrorScreen: false,
        getProvidersErrorMessage: this.$route.meta.getProvidersErrorMessage,
        showProviderRequiredDialog: false,
        showBankAccountRequiredScreen: false,
        showGetBankAccountsErrorScreen: false,
        getBankAccountsErrorMessage: this.$route.meta.getBankAccountsErrorMessage,
        showReimburseByCheckDialog: false,
        showPossibleDuplicateClaimDialog: false,
        showMissingPatientNameDialog: false,
        isDuplicateOverride: false,
        distributionReasonOptions: [
          {
            text: this.$options.filters.t(
              'submit-claim_label_distribution-option_normal-distribution',
            ),
            value: 'normal-distribution',
          },
          {
            text: this.$options.filters.t(
              'submit-claim_label_distribution-option_excess-contribution-removal',
            ),
            value: 'excess-contribution-removal',
          },
          {
            text: this.$options.filters.t(
              'submit-claim_label_distribution-option_disability',
            ),
            value: 'disability',
          },
          {
            text: this.$options.filters.t(
              'submit-claim_label_distribution-option_prohibited-transaction',
            ),
            value: 'prohibited-transaction',
          },
        ],
        serviceTypes: [
          {
            text: this.$options.filters.t(
              'submit-claim_label_service-option_medical',
            ),
            value: 'medical',
          },
          {
            text: this.$options.filters.t(
              'submit-claim_label_service-option_pharmacy',
            ),
            value: 'pharmacy',
          },
          {
            text: this.$options.filters.t(
              'submit-claim_label_service-option_vision',
            ),
            value: 'vision',
          },
          {
            text: this.$options.filters.t(
              'submit-claim_label_service-option_dental',
            ),
            value: 'dental',
          },
        ],
        confirmBeforeClose: true,
        submitIsLoading: false,
        showSubmitSuccessMessage: false,
        submitGetReimbursedSuccessMessage: this.$route.meta
          .submitGetReimbursedSuccessMessage,
        submitPayBillSuccessMessage: this.$route.meta.submitPayBillSuccessMessage,
        showSubmitErrorMessage: false,
        submitErrorMessage: this.$route.meta.submitErrorMessage,
        encryptedPDFError: false,
        errorEncryptedPDFMessage: this.$route.meta.errorEncryptedPDFMessage,
        badFileError: false,
        errorBadFileMessage: this.$route.meta.errorBadFileMessage,
        dialogMaxWidth,
        dateTransactionFormat,
        duplicateClaim: [],
      };
    },
    beforeMount() {
      if (this.accountOptions.length === 1) {
        this.account = this.accountOptions[0];
      }
      this.constructShowErrorModel('formModel');
      this.showErrorModel.account = false;
      if (this.$route.params.providerId) {
        this.setPayToOption(this.$route.params.providerId);
      }

      EventBus.$on('refreshProviders', (response) => {
        this.setPayToOption(response.providerId);
      });
    },
    validations: {
      // requireIf - Must use function declaration instead of arrow function to access `this` scope
      account: {
        required,
      },
      formModel: {
        amount: {
          required,
          minValue(value): boolean {
            const val = InputMaskTypes.currency.deconstruct(value),
              valNum = parseFloat(val);
            return !req(value) || (!isNaN(valNum) && valNum > 0);
          },
          maxValue(value): boolean {
            const val = InputMaskTypes.currency.deconstruct(value),
              valNum = parseFloat(val);
            return !req(value) || (!isNaN(valNum) && valNum <= 999999999999.99);
          },
        },
        sendTo: {
          required: requiredIf(function (this: any): boolean {
            return this.isGetReimbursedFlow;
          }),
        },
        payTo: {
          required: requiredIf(function (this: any): boolean {
            return this.isPayBillFlow;
          }),
        },

        // Non-HSA only
        serviceFromDate: {
          required: requiredIf(function (this: any): boolean {
            return this.isNonHSAFlow;
          }),
          date,
          beforeServiceToDate(value): boolean {
            return (
              // @ts-ignore
              !this.$v.formModel.serviceToDate.date ||
              dateHelpers.sameOrBeforeDate(
                moment(this.formModel.serviceToDate, dateFormat)
                  .format(
                    dateFormat,
                  ),
              )(value)
            );
          },
          futureDate(value): boolean {
            return this.isMedicalFlow || this.isAdoptionFlow
              ? dateHelpers.sameOrBeforeDate(moment()
                .format(dateFormat))(value)
              : true;
          },
          withinPastTwoYears(value): boolean {
            return dateHelpers.sameOrAfterDate(
              moment()
                .subtract(2, 'years')
                .format(dateFormat),
            )(value);
          },
        },
        serviceToDate: {
          required: requiredIf(function (this: any): boolean {
            return this.isNonHSAFlow;
          }),
          date,
          afterServiceFromDate(value): boolean {
            return (
              // @ts-ignore
              !this.$v.formModel.serviceFromDate.date ||
              dateHelpers.sameOrAfterDate(
                moment(this.formModel.serviceFromDate, dateFormat)
                  .format(
                    dateFormat,
                  ),
              )(value)
            );
          },
          futureDate(value): boolean {
            return this.isMedicalFlow || this.isAdoptionFlow
              ? dateHelpers.sameOrBeforeDate(moment()
                .format(dateFormat))(value)
              : true;
          },
          within30Days(value): boolean {
            const future30Days = moment()
              .add(30, 'days');
            return this.isDependentCareFlow || this.isPremiumReimbursementFlow
              ? dateHelpers.sameOrBeforeDate(future30Days.format(dateFormat))(
                value,
              )
              : true;
          },
          withinPastTwoYears(value): boolean {
            return dateHelpers.sameOrAfterDate(
              moment()
                .subtract(2, 'years')
                .format(dateFormat),
            )(value);
          },
        },

        // Medical or Dental only
        providerName: {
          required: requiredIf(function (this: any): boolean {
            return (
              this.isGetReimbursedFlow &&
              (this.isMedicalFlow || this.isDependentCareFlow || this.isAdoptionFlow)
            );
          }),
          maxLength: maxLength(100),
        },

        // HSA only
        noteToSelf: {
          maxLength: maxLength(256),
        },
        distributionReason: {
          required: requiredIf(function (this: any): boolean {
            return this.isHSAFlow;
          }),
        },
        termsAndConditionsHSA: {
          required: requiredIf(function (this: any): boolean {
            return this.isHSAFlow;
          }),
        },

        // Medical only
        patientName: {
          required: requiredIf(function (this: any): boolean {
            return this.isMedicalFlow;
          }),
          maxLength: maxLength(150),
        },
        patientNameOther: {
          required: requiredIf(function (this: any): boolean {
            return this.isMedicalFlow && this.isPatientNameOther;
          }),
          maxLength: maxLength(150),
        },
        serviceType: {
          required: requiredIf(function (this: any): boolean {
            return this.isMedicalFlow;
          }),
        },

        // Dependent care only
        providerTaxID: {
          numeric,
          exactLength: exactLength(9),
          taxIdNumber,
        },
        dependentName: {
          required: requiredIf(function (this: any): boolean {
            return this.isDependentCareFlow;
          }),
          maxLength: maxLength(150),
        },
        dependentNameOther: {
          required: requiredIf(function (this: any): boolean {
            return this.isDependentCareFlow && this.isDependentNameOther;
          }),
          maxLength: maxLength(150),
        },

        // Adoption only
        childName: {
          maxLength: maxLength(150),
        },

        // Premium reimbursement only
        insuranceCarrier: {
          required: requiredIf(function (this: any): boolean {
            return this.isGetReimbursedFlow && this.isPremiumReimbursementFlow;
          }),
        },
        policyholderName: {
          required: requiredIf(function (this: any): boolean {
            return this.isPremiumReimbursementFlow;
          }),
          maxLength: maxLength(150),
        },
        coverageType: {
          required: requiredIf(function (this: any): boolean {
            return this.isPremiumReimbursementFlow;
          }),
        },

        // Review screen only
        termsAndConditionsSubmit: {
          required: requiredIf(function (this: any): boolean {
            const currentStepConfig = this.steps[parseInt(this.currentStep) - 1];
            return currentStepConfig.ref === 'review';
          }),
        },
      },
    },
    computed: {
      attachDocumentsGuidelines(): any {
        return this.isDependentCareFlow
          ? this.dcapUploadDocuments
          : this.guidelines;
      },
      nonHSATermsAndConditions(): string {
        if (this.isDependentCareFlow) {
          return 'submit-claim_form-label_terms-and-conditions-dcap_submit';
        }

        return 'submit-claim_form-label_terms-and-conditions_submit';
      },
      personalInformation(): MemberPersonalInformationResponseModel {
        return this.$store.getters.personalInformation;
      },
      stepsDisabled(): boolean {
        return (
          this.submitIsLoading ||
          this.getDataIsLoading ||
          this.showSubmitSuccessMessage ||
          this.showSubmitErrorMessage ||
          this.showGetProvidersErrorScreen ||
          this.showGetBankAccountsErrorScreen
        );
      },
      submitSuccessMessage(): string {
        return this.isGetReimbursedFlow
          ? this.submitGetReimbursedSuccessMessage
          : this.submitPayBillSuccessMessage;
      },
      showEncryptedPDFError(): boolean {
        return this.showSubmitErrorMessage && this.encryptedPDFError;
      },
      showBadFileError(): boolean {
        return this.showSubmitErrorMessage && this.badFileError;
      },
      showGeneralError(): boolean {
        return (
          this.showSubmitErrorMessage &&
          !(this.encryptedPDFError || this.badFileError)
        );
      },
      showSubmitButtonLabel(): string {
        if (this.isNonHSAFlow) {
          return 'submit-claim_action_continue';
        }

        return 'submit-claim_action_submit';
      },
      // Steps
      steps(): StepperSteps[] {
        let steps = [
          // Choose Amount
          {
            ref: 'chooseAmount',
            name: ['submit-claim_label_enter-total'],
            showBack: true,
            isCompleted: false,
            isEditable: false,
          },
          {
            ref: 'claimInfo',
            name: ['submit-claim_label_enter-information'],
            showBack: true,
            isCompleted: false,
            isEditable: false,
          },
        ];

        // Add Choose Account step if there are more than 1 claim type options
        if (this.accountOptions.length > 1) {
          steps.unshift({
            ref: 'chooseAccount',
            name: ['submit-claim_label_choose-account'],
            showBack: false,
            isCompleted: false,
            isEditable: false,
          });
        }

        // Add Attach Documents step if selectedAccount is not HSA
        if (this.isNonHSAFlow) {
          // Add Attach Documents screen
          steps.push({
            ref: 'attachDocuments',
            name: [
              'submit-claim_label_attach-documents',
              'global_attach-documents',
            ],
            showBack: true,
            isCompleted: false,
            isEditable: false,
          });
          // Add Review screen
          steps.push({
            ref: 'review',
            name: ['submit-claim_label_review', 'global_review'],
            showBack: true,
            isCompleted: false,
            isEditable: false,
          });
        }

        if (this.isDependentCareFlow) {
          this.dcapUploadDocuments = this.$route.meta.dcapUploadDocuments;
        } else {
          this.dcapUploadDocuments = null;
        }

        // Calculate stepPosition for each step
        steps = steps.map((step, index) => {
          const newStep: StepperSteps = {} as StepperSteps;
          if (index === 0) {
            newStep.showBack = false;
          }
          newStep.stepPosition = (index + 1).toString();
          return Object.assign(step, newStep);
        });
        return steps;
      },
      // Create steps map
      stepsMap(): any {
        return this.steps.reduce((map, obj) => {
          map[obj.ref] = obj;
          return map;
        }, {});
      },

      // Getters
      accounts(): MemberAccountResponseModel[] {
        return this.$store.getters.accounts;
      },
      providers(): MemberProvidersResponseModel[] {
        return this.$store.getters.providers;
      },
      primaryBankAccount(): MemberBankAccountResponseModel {
        return this.$store.getters.primaryBankAccount;
      },
      dependents(): MemberDependentResponseModel[] {
        return this.$store.getters.dependents;
      },

      // Conditional flags
      isGetReimbursedFlow(): boolean {
        return this.claimAction === 'reimburse';
      },
      isPayBillFlow(): boolean {
        return this.claimAction === 'pay-bill';
      },
      isHSAFlow(): boolean {
        return this.selectedAccount && this.selectedAccount.productType === 'HSA';
      },
      isNonHSAFlow(): boolean {
        return this.selectedAccount && this.selectedAccount.productType !== 'HSA';
      },
      isAdoptionFlow(): boolean {
        return this.selectedAccount && this.selectedAccount.productType === 'AAP';
      },
      isMedicalFlow(): boolean {
        return (
          this.selectedAccount &&
          (this.selectedAccount.productType === 'FSA' ||
            this.selectedAccount.productType === 'HIA' ||
            this.selectedAccount.productType === 'VEBA' ||
            this.selectedAccount.productType === 'HRA')
        );
      },
      isDependentCareFlow(): boolean {
        return (
          this.selectedAccount && this.selectedAccount.productType === 'DCAP'
        );
      },
      isPremiumReimbursementFlow(): boolean {
        return this.selectedAccount && this.selectedAccount.productType === 'PRA';
      },
      isPatientNameOther(): boolean {
        return this.formModel.patientName.name === 'Other';
      },
      isDependentNameOther(): boolean {
        return this.formModel.dependentName.name === 'Other';
      },

      sendToValue(): string {
        const maskedAccountNumber = this.$options.filters.maskedLast4Digits(
          this.primaryBankAccount.accountNumber,
        );
        return `${this.primaryBankAccount.name} ${
          this.primaryBankAccount.accountType
        } (Account Ending ${maskedAccountNumber})`;
      },
      reviewServiceTypeValue(): null | string {
        if (this.formModel.serviceType) {
          const serviceIndex = this.serviceTypes.findIndex((service) => {
            return service.value === this.formModel.serviceType;
          });
          return this.serviceTypes[serviceIndex].text;
        }
        return null;
      },
      accountOptions(): SelectOption[] {
        //        Get active accounts and their account types
        const activeAccounts = this.accounts.filter((account) => {
          if (this.isPayBillFlow) {
            // MBR-030 BR1.02
            return account.isActive && account.productType !== 'TRA' && account.productType !== 'AAP';
          } else {
            // MBR-030 BR1.02
            return account.isActive && account.productType !== 'TRA';
          }
        });
        let accounts = activeAccounts.map((account) => {
          return {
            text: `${account.productType} (${this.$options.filters.t(
              'global_effective-date-label',
            )} ${account.startDate})`,
            value: `${account.productType}-${account.accountId}`,
            accountId: account.accountId,
            productType: account.productType,
          };
        });
        accounts = accounts.sort((a, b) => {
          if (a.value < b.value) {
            return -1;
          }
          if (a.value > b.value) {
            return 1;
          }
          return 0;
        });
        return accounts;
      },
      // TODO replace
      selectedAccount: {
        get() {
          if (this.account) {
            // @ts-ignore
            return this.account;
          } else if (this.initAccountId) {
            // @ts-ignore
            const match = this.accountOptions.find((account) => {
              return (
                this.initAccountId.toString() === account.accountId.toString()
              );
            });
            this.account = match;
            return match;
          }
        },
        set(val) {
          this.account = val;
        },
      },
      showStackingAccountInfo(): boolean {
        const medicalAccountTypes = [];
        this.accountOptions.forEach((account) => {
          if (
            account.productType === 'FSA' ||
            account.productType === 'HRA' ||
            account.productType === 'VEBA'
          ) {
            medicalAccountTypes.push(account.productType);
          }
        });
        return (
          medicalAccountTypes.length > 1 &&
          medicalAccountTypes.indexOf(this.account.productType) > -1
        );
      },
      payToOptions(): SelectOption[] {
        const sortedProviders = this.providers.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        return sortedProviders.map((provider) => {
          return {
            text: `${provider.name} (Acct: ${provider.accountNumber})`,
            name: provider.name,
            value: provider.providerId,
          };
        });
      },
      dependentOptions(): SelectOption[] {
        const otherOption = {
          text: 'Other',
          name: 'Other',
          value: null,
        };
        const sortedDependents = this.dependents.sort((a, b) => {
          if (a.firstName < b.firstName) {
            return -1;
          }
          if (a.firstName > b.firstName) {
            return 1;
          }
          return 0;
        });

        if (!this.isHSAFlow && sortedDependents.length > 0) {
          this.formModel.patientName = {
            text: `${sortedDependents[0].firstName} ${sortedDependents[0].lastName}`,
            name: sortedDependents[0].firstName,
            value: sortedDependents[0].dependentId,
          };
        }

        if (sortedDependents.length === 0) {
          return [otherOption];
        } else {
          return [
            ...sortedDependents.map((dependent) => {
              return {
                text: `${dependent.firstName} ${dependent.lastName}`,
                name: dependent.firstName,
                value: dependent.dependentId,
              };
            }),
            otherOption,
          ];
        }
      },
      serviceTypeHSAPayload(): string {
        let serviceTypeCode;
        switch (this.formModel.distributionReason) {
          case 'normal-distribution':
            serviceTypeCode = 'NORM';
            break;
          case 'excess-contribution-removal':
            serviceTypeCode = 'EXCE';
            break;
          case 'disability':
            serviceTypeCode = 'DISA';
            break;
          case 'prohibited-transaction':
            serviceTypeCode = 'PROH';
            break;
          default:
            serviceTypeCode = 'NORM';
        }
        return serviceTypeCode;
      },
      serviceTypeNonHSAPayload(): string {
        let serviceType;
        switch (this.formModel.serviceType) {
          case 'medical':
            serviceType = 'MEDI';
            break;
          case 'pharmacy':
            serviceType = 'DRUG';
            break;
          case 'dental':
            serviceType = 'DNTL';
            break;
          case 'vision':
            serviceType = 'VISI';
            break;
          default:
            serviceType = '';
        }
        if (this.isDependentCareFlow) {
          serviceType = 'DEPC';
        } else if (this.isPremiumReimbursementFlow) {
          serviceType = 'INSP';
        } else if (this.isAdoptionFlow) {
          serviceType = 'ADOP';
        }
        return serviceType;
      },
      submitClaimAmountPageTitle(): string {
        let text: string;
        if (this.isGetReimbursedFlow) {
          if (this.isHSAFlow) {
            text = 'submit-claim_claim-amount_reimburse-hsa_page-title';
          } else {
            text = 'submit-claim_claim-amount_reimburse-non-hsa_page-title';
          }
        } else if (this.isPayBillFlow) {
          if (this.isHSAFlow) {
            text = 'submit-claim_claim-amount_pay-bill-hsa_page-title';
          } else {
            text = 'submit-claim_claim-amount_pay-bill-non-hsa_page-title';
          }
        }
        return this.$options.filters.t(text);
      },
      submitClaimAmountPageDescription(): string {
        let text: string;
        if (this.isGetReimbursedFlow) {
          if (this.isHSAFlow) {
            text = 'submit-claim_claim-amount_reimburse-hsa_page-description';
          } else {
            text =
              'submit-claim_claim-amount_reimburse-non-hsa_page-description';
          }
        } else if (this.isPayBillFlow) {
          if (this.isHSAFlow) {
            text = 'submit-claim_claim-amount_pay-bill-hsa_page-description';
          } else {
            text =
              'submit-claim_claim-amount_pay-bill-non-hsa_page-description';
          }
        }
        return this.$options.filters.t(text);
      },
      documentsToUpload(): any[] {
        return this.selectedFiles.filter((file: any) => {
          return file.vaultId === null || typeof file.vaultId === 'undefined';
        });
      },
      documentsToAttachFromVault(): any[] {
        return this.selectedFiles.filter((file: any) => {
          return file.vaultId !== null && typeof file.vaultId !== 'undefined';
        });
      },

      // VALIDATIONS
      accountErrors(): string[] {
        const formField = 'account';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_account_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      amountErrors(): string[] {
        const formField = 'formModel.amount';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_amount_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_amount_min-value',
            'minValue',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_amount_max-value',
            'maxValue',
          ),
        ]);
      },
      sendToErrors(): string[] {
        const formField = 'formModel.sendTo';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_send-to_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      payToErrors(): string[] {
        const formField = 'formModel.payTo';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_pay-to_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      serviceFromDateErrors(): string[] {
        const formField = 'formModel.serviceFromDate';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_service-from-date_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_service-from-date_invalid-format',
              'global_form-error_date_invalid-format',
            ],
            'date',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-from-date_invalid',
            'beforeServiceToDate',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-from-date_future',
            'futureDate',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-from-date_two-years',
            'withinPastTwoYears',
          ),
        ]);
      },
      serviceToDateErrors(): string[] {
        const formField = 'formModel.serviceToDate';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_service-to-date_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_service-to-date_invalid-format',
              'global_form-error_date_invalid-format',
            ],
            'date',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-to-date_invalid',
            'afterServiceFromDate',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-to-date_future',
            'futureDate',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-to-date_30-days',
            'within30Days',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_service-to-date_two-years',
            'withinPastTwoYears',
          ),
        ]);
      },
      providerNameErrors(): string[] {
        const formField = 'formModel.providerName';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_provider-name_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_provider-name_length',
            'maxLength',
            {key: 'maxLength', val: 'max'},
          ),
        ]);
      },
      patientNameErrors(): string[] {
        const formField = 'formModel.patientName';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_patient-name_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      patientNameOtherErrors(): string[] {
        const formField = 'formModel.patientNameOther';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_patient-name_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_patient-name_length',
            'maxLength',
            {key: 'maxLength', val: 'max'},
          ),
        ]);
      },
      termsAndConditionsSubmitErrors(): string[] {
        const formField = 'formModel.termsAndConditionsSubmit';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_terms-and-conditions_required',
              'global_form-error_terms-and-conditions_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      // HSA only
      distributionReasonErrors(): string[] {
        const formField = 'formModel.distributionReason';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_distribution-reason_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      termsAndConditionsHsaErrors(): string[] {
        const formField = 'formModel.termsAndConditionsHSA';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_terms-and-conditions_required',
              'global_form-error_terms-and-conditions_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },

      // Medical only
      serviceTypeErrors(): string[] {
        const formField = 'formModel.serviceType';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_service-type_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },

      // Dependent care only
      providerTaxIdErrors(): string[] {
        const formField = 'formModel.providerTaxID';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_provider-tax-id_invalid-format',
              'global_form-error_default_required',
            ],
            'numeric',
          ),
          this.FormValidationMixin.validateField(
            formField,
            ['submit-claim_form-error_provider-tax-id_invalid-tax-id'],
            'taxIdNumber',
          ),
          this.FormValidationMixin.validateField(
            formField,
            ['submit-claim_form-error_provider-tax-id_invalid-format'],
            'exactLength',
            {key: 'exactLength', val: 'length'},
          ),
        ]);
      },
      dependentNameErrors(): string[] {
        const formField = 'formModel.dependentName';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_dependent-name_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      dependentNameOtherErrors(): string[] {
        const formField = 'formModel.dependentNameOther';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_dependent-name_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_dependent-name_length',
            'maxLength',
            {key: 'maxLength', val: 'max'},
          ),
        ]);
      },
      childNameErrors(): string[] {
        const formField = 'formModel.childName';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_child-name_length',
            'maxLength',
            {key: 'maxLength', val: 'max'},
          ),
        ]);
      },


      // Premium reimbursement only
      insuranceCarrierErrors(): string[] {
        const formField = 'formModel.insuranceCarrier';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_insurance-carrier_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      policyholderNameErrors(): string[] {
        const formField = 'formModel.policyholderName';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_policyholder-name_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_policyholder-name_length',
            'maxLength',
            {key: 'maxLength', val: 'max'},
          ),
        ]);
      },
      coverageTypeErrors(): string[] {
        const formField = 'formModel.coverageType';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            [
              'submit-claim_form-error_coverage-type_required',
              'global_form-error_default_required',
            ],
            'required',
          ),
        ]);
      },
      noteToSelfErrors(): string[] {
        const formField = 'formModel.noteToSelf';
        return this.FormValidationMixin.constructErrors(formField, [
          this.FormValidationMixin.validateField(
            formField,
            'submit-claim_form-error_note-to-self_length',
            'maxLength',
            {key: 'maxLength', val: 'max'},
          ),
        ]);
      },
    },
    watch: {
      providers(val, oldVal): void {
        if (val.length && !oldVal.length) {
          this.showProviderRequiredScreen = false;
          if (val.length === 1) {
            // @ts-ignore
            this.formModel.payTo = this.payToOptions[0];
          }
        }
      },
      primaryBankAccount(val, oldVal): void {
        if (val && !oldVal) {
          this.showBankAccountRequiredScreen = false;
          this.formModel.sendTo = this.sendToValue;
        }
      },
    },
    methods: {
      tryAgain(): void {
        this.showSubmitErrorMessage = false;
        this.confirmBeforeClose = true;
      },
      setSelectedFiles(files): void {
        this.selectedFiles = files;
      },
      updateServiceFromDate(fromDate): void {
        this.formModel.serviceFromDate = this.formatDate(fromDate);
        this.triggerBlur('formModel.serviceFromDate');
        this.updateHasChanged();
        // If the service to date hasn't been set yet
        // set it to the service from date
        // and trigger the blur method on the service to date
        if (!this.formModel.serviceToDate) {
          this.formModel.serviceToDate = this.formModel.serviceFromDate;
          this.deconstructServiceToDate();
          this.triggerBlur('formModel.serviceToDate');
        }
      },
      serviceFromDateInput(): void {
        this.triggerInputOrChange('formModel.serviceFromDate');
        if (
          !this.formModel.serviceToDate &&
          !this.$v.formModel.serviceFromDate.$invalid
        ) {
          this.formModel.serviceToDate = this.formModel.serviceFromDate;
          this.deconstructServiceToDate();
          this.triggerBlur('formModel.serviceToDate');
        }
      },
      updateServiceToDate(serviceToDate): void {
        this.formModel.serviceToDate = this.formatDate(serviceToDate);
        this.triggerBlur('formModel.serviceToDate');
        this.updateHasChanged();
      },
      setNumber(value: string): void {
        this.formModel.amount = parseFloat(value).toFixed(2);
      },
      nextStep(): void {
        this.$v.$reset();
        this.changeMade = true;
        this.formModel.termsAndConditionsSubmit = false;
        if (this.currentStep < this.steps.length) {
          this.steps[this.currentStep - 1].isCompleted = true;
          this.currentStep++;

          // Trigger getProviders or getBankingInformation when user gets to the Claim Information step
          const currentStepConfig = this.steps[this.currentStep - 1];
          if (currentStepConfig.ref === 'claimInfo') {
            if (this.isGetReimbursedFlow) {
              this.triggerGetBankingInformation();
              this.triggerGetDependents();
            } else if (this.isPayBillFlow) {
              this.triggerGetProviders();
              this.triggerGetDependents();
            }
          }
        }
      },
      setStep(step): void {
        this.currentStep = step;
      },
      allowedServiceFromDates(serviceFromDate): boolean {
        let allowed = moment(serviceFromDate, datePickerFormat)
          .isSameOrAfter(
            moment()
              .subtract(2, 'years')
              .startOf('day'),
          );
        if (this.isMedicalFlow) {
          allowed = allowed && moment(serviceFromDate, datePickerFormat)
            .isSameOrBefore(moment(), 'day');
        }
        return allowed;
      },
      allowedServiceToDates(serviceToDate): boolean {
        let allowed = moment(serviceToDate, datePickerFormat)
          .isSameOrAfter(
            moment()
              .subtract(2, 'years')
              .startOf('day'),
          );
        if (this.isMedicalFlow) {
          allowed = allowed && moment(serviceToDate, datePickerFormat)
            .isSameOrBefore(moment(), 'day');
        } else if (this.isDependentCareFlow || this.isPremiumReimbursementFlow) {
          const future30Days = moment()
            .add(30, 'days');
          allowed = allowed && moment(serviceToDate, datePickerFormat)
            .isSameOrBefore(
              future30Days,
              'day',
            );
        }
        return allowed;
      },
      editClaimInformation(): void {
        const claimInfoStepIndex = this.steps.findIndex((step) => {
          return step.ref === 'claimInfo';
        });
        this.setStep(claimInfoStepIndex + 1);
      },
      editAttachments(): void {
        const attachDocumentsStepIndex = this.steps.findIndex((step) => {
          return step.ref === 'attachDocuments';
        });
        this.setStep(attachDocumentsStepIndex + 1);
      },
      triggerGetBankingInformation(): void {
        this.getDataIsLoading = true;
        this.$store
          .dispatch('getBankingInformation')
          .then(() => {
            if (!this.primaryBankAccount) {
              this.showBankAccountRequiredScreen = true;
            } else {
              this.formModel.sendTo = this.sendToValue;
            }
            this.getDataIsLoading = false;
          })
          .catch(() => {
            this.showBankAccountRequiredScreen = true;
            this.showGetBankAccountsErrorScreen = true;
            this.getDataIsLoading = false;
          });
      },
      openReimburseByCheckDialog(): void {
        this.showReimburseByCheckDialog = true;
      },
      closeReimburseByCheckDialog(): void {
        this.reimburseByCheck = false;
        this.showReimburseByCheckDialog = false;
      },
      openPossibleDuplicateClaimDialog(): void {
        this.getDataIsLoading = false;
        this.submitIsLoading = false;
        this.showPossibleDuplicateClaimDialog = true;
      },
      closePossibleDuplicateClaimDialog(): void {
        this.showPossibleDuplicateClaimDialog = false;
      },
      proceedPossibleDuplicateClaimDialog(): void {
        this.showPossibleDuplicateClaimDialog = false;
        this.isDuplicateOverride = true;
        if (this.isHSAFlow) {
          this.submitHSAClaim();
        } else {
          this.submitNonHSAClaim();
        }
      },
      openMissingPatientNameDialog(): void {
        this.showMissingPatientNameDialog = true;
      },
      closeMissingPatientNameDialog(): void {
        // MBR-030 - BR-3.31a – If the Actor clicks “No” to the message in BR-3.31,
        // the System returns the Actor back to the form
        this.showMissingPatientNameDialog = false;
      },
      proceedMissingPatientNameDialog(): void {
        this.showMissingPatientNameDialog = false;
        this.checkDuplicateSamAndSalesforceClaim();
      },
      closeBankAccountRequiredScreen(): void {
        this.closeReimburseByCheckDialog();
        this.formModel.sendTo = this.$options.filters.t(
          'submit-claim_text_manual-check',
        );
        this.showBankAccountRequiredScreen = false;
      },
      triggerGetProviders(): void {
        this.getDataIsLoading = true;
        this.$store
          .dispatch('getProviders')
          .then(() => {
            if (!this.providers.length) {
              this.showProviderRequiredScreen = true;
            }
            this.getDataIsLoading = false;
          })
          .catch(() => {
            this.showProviderRequiredScreen = true;
            this.showGetProvidersErrorScreen = true;
            this.getDataIsLoading = false;
          });
      },
      triggerGetDependents(): void {
        this.getDataIsLoading = true;
        this.$store
          .dispatch('getDependents')
          .then(() => {
            this.getDataIsLoading = false;
          });
      },
      toggleProviderRequiredDialog(): void {
        this.showProviderRequiredDialog = !this.showProviderRequiredDialog;
      },
      closeProviderRequiredScreen(): void {
        this.toggleProviderRequiredDialog();
        this.claimAction = 'reimburse';
        this.showProviderRequiredScreen = false;
        this.triggerGetBankingInformation();
      },
      deconstructProviderTaxID(): void {
        this.formModel.providerTaxID = InputMaskTypes.numerical.deconstruct(
          this.formModel.providerTaxID,
        );
      },
      deconstructServiceFromDate(): void {
        this.formModel.serviceFromDate = InputMaskTypes.date.deconstruct(
          this.formModel.serviceFromDate,
        );
      },
      deconstructServiceToDate(): void {
        this.formModel.serviceToDate = InputMaskTypes.date.deconstruct(
          this.formModel.serviceToDate,
        );
      },
      removeSelectedFile(index): void {
        const file = this.selectedFiles[index];
        EventBus.$emit('removeSelectedFile', index, file);
      },
      constructHSAClaimPayload(): any {
        let providerId = null;
        let isPayTheProvider = null;
        let providerName = null;
        let hsaPatientName = null;
        let hsaDependentId = null;

        if (this.isPayBillFlow) {
          providerId = this.formModel.payTo.value.toString();
          providerName = this.formModel.payTo.name;

          if (!this.isPatientNameOther && !isEmpty(this.formModel.patientName) && this.formModel.patientName.text.length > 0) {
            hsaPatientName = this.formModel.patientName.text;
            hsaDependentId = this.formModel.patientName.value.toString();
          }
          if (this.isPatientNameOther && !isNil(this.formModel.patientNameOther) && this.formModel.patientNameOther.length > 0) {
            hsaPatientName = this.formModel.patientNameOther;
          }
        }

        // determine isPayTheProvider field
        if (this.isPayBillFlow) {
          isPayTheProvider = true;
        } else if (this.isGetReimbursedFlow) {
          isPayTheProvider = false;
        }

        return {
          memberId: this.$store.getters.user.memberId.toString(),
          memberAccountId: this.selectedAccount.accountId.toString(),
          startDate: null,
          endDate: null,
          serviceTypeCode: this.serviceTypeHSAPayload,
          isPayTheProvider,
          providerId,
          patientName: hsaPatientName,
          providerTaxId: null, // REMOVE
          providerName,
          amount: this.formModel.amount,
          noteToSelf: this.formModel.noteToSelf,
          dependentId: hsaDependentId,
          isDuplicateOverride: this.isDuplicateOverride,
        };
      },
      async submitHSAClaim(): Promise<any> {
        this.submitIsLoading = true;
        this.$store
          .dispatch('addMemberClaimRequest', this.constructHSAClaimPayload())
          .then((claim) => {
            this.showSuccess();
          })
          .catch(() => {
            this.showError();
          });
      },
      checkDuplicateSamAndSalesforceClaim(): void {
        this.submitIsLoading = true;
        this.$store
          .dispatch('checkSAMAndSalesforceDuplicateClaim', this.constructCheckDuplicateClaimParams())
          .then((claim) => {
            if (claim) {
              this.duplicateClaim = claim.duplicateClaims[0];
              this.duplicateClaim.startDate = claim.startDate;
              this.openPossibleDuplicateClaimDialog();
            } else {
              if (this.isHSAFlow) {
                this.submitHSAClaim();
              } else if (this.isNonHSAFlow) {
                this.submitNonHSAClaim();
              }
            }
          })
          .catch(() => {
            this.showError();
          });
      },
      checkMissingPatientName(): void {
        // MBR-030 - BR-3.31 – If the Actor elected “Pay a Bill” and clicks the Next button
        // and the Account Type is equal to “HSA” and the Patient Name field is not populated,
        // the System will present the Actor with the message “Not including the Patient Name
        // might impact the provider's ability to process the payment. Are you sure you want to
        // continue?” along with the options “Yes” and “No”.  The Actor must click on “Yes” to continue.
        if (this.isHSAFlow &&
          this.isPayBillFlow &&
          (
            // no patient name selected from dropdown
            (!this.isPatientNameOther && (isEmpty(this.formModel.patientName) || this.formModel.patientName.text.length === 0)) ||
            // Other selected in Patient nane dropdown but no name entered into the other pathent name field
            (this.isPatientNameOther && (isNil(this.formModel.patientNameOther) || this.formModel.patientNameOther.length === 0))
          )) {
          // patient name missing
          this.openMissingPatientNameDialog();
        } else {
          this.checkDuplicateSamAndSalesforceClaim();
        }
      },
      constructCheckDuplicateClaimParams(): any {
        if (this.isHSAFlow) {
          return {
            amount: this.formModel.amount,
            startDate: moment()
              .format(datePickerFormat),
            memberId: this.$store.getters.user.memberId,
          };
        } else if (this.isNonHSAFlow) {
          return {
            amount: this.formModel.amount,
            startDate: moment(this.formModel.serviceFromDate, dateFormat).format(datePickerFormat),
            memberId: this.$store.getters.user.memberId,
          };
        }
      },
      constructNonHSAClaimPayload(uploadedFileUUIDs): any {
        let providerName = this.formModel.providerName
          ? this.formModel.providerName
          : null,
          patientName,
          providerId,
          isPayTheProvider,
          dependentId;

        if (this.isPayBillFlow) {
          providerName = this.formModel.payTo.name;
          providerId = this.formModel.payTo.value.toString();
        }

        // MBR-030 BR-3.11-3.20
        // This determines the values of patientName and dependentId in the request params
        // Depending on the different flows and if the user has selected 'Other' for Patient/Dependent Names
        // If it is a isDepdentCareFlow we will use dependent values
        // If the user has selected 'Other' then we shall use the free text field patientNameOther or dependentNameOther
        if (this.isMedicalFlow && this.isPatientNameOther) {
          patientName = this.formModel.patientNameOther;
          dependentId = null;
        } else if (this.isMedicalFlow && !this.isPatientNameOther) {
          patientName = this.formModel.patientName.text;
          dependentId = this.formModel.patientName.value.toString();
        } else if (this.isDependentCareFlow && this.isDependentNameOther) {
          patientName = this.formModel.dependentNameOther;
          dependentId = null;
        } else if (this.isDependentCareFlow && !this.isDependentNameOther) {
          patientName = this.formModel.dependentName.text;
          dependentId = this.formModel.dependentName.value.toString();
        } else if (this.isPremiumReimbursementFlow) {
          patientName = this.formModel.policyholderName;
          if (this.isGetReimbursedFlow) {
            providerName = this.formModel.insuranceCarrier;
          }
        } else if (this.isAdoptionFlow) {
          patientName = this.formModel.childName;
        }

        // determine isPayTheProvider field
        if (this.isPayBillFlow) {
          isPayTheProvider = true;
        } else if (this.isGetReimbursedFlow) {
          isPayTheProvider = false;
        }

        const images = this.createVaultDataPayload(
          uploadedFileUUIDs,
          this.serviceTypeNonHSAPayload,
        );

        return {
          memberId: this.$store.getters.user.memberId.toString(),
          memberAccountId: this.selectedAccount.accountId.toString(),
          startDate: this.formModel.serviceFromDate,
          endDate: this.formModel.serviceToDate,
          serviceTypeCode: this.serviceTypeNonHSAPayload,
          isPayTheProvider,
          providerId,
          patientName,
          providerTaxId: this.formModel.providerTaxID,
          providerName,
          amount: this.formModel.amount,
          noteToSelf: this.formModel.noteToSelf,
          images,
          dependentId,
          isDuplicateOverride: this.isDuplicateOverride,
        };
      },
      async submitNonHSAClaim(): Promise<any> {
        this.submitIsLoading = true;
        const UPLOADED_FILE_UUIDS =
          this.documentsToUpload.length === 0
            ? []
            : await this.uploadFiles(this.documentsToUpload);
        const payload = this.constructNonHSAClaimPayload(UPLOADED_FILE_UUIDS);

        this.$store
          .dispatch('addMemberClaimRequest', payload)
          .then((claim) => {
            this.showSuccess();
          })
          .catch(() => {
            this.showError();
          });
      },
      createVaultDataPayload(uploadedFileUUIDs, serviceType): any {
        const ATTACH_PAYLOAD = this.documentsToAttachFromVault.map((document) => {
          const fileExt = FileUtils.getFilenameExtension(document.fileName);
          return {
            vaultId: `${document.vaultId}`,
            imageFileName: document.fileName,
            imageFileNickname: document.fileNickname,
            uploadDate: document.uploadDate,
            imageId: document.uuid,
          };
        });
        const UPLOADED_PAYLOAD = uploadedFileUUIDs
          ? Object.entries(uploadedFileUUIDs)
            .map((keyValueArray) => {
              return {
                imageFileName: keyValueArray[0],
                imageFileNickname: keyValueArray[0],
                imageId: keyValueArray[1],
              };
            })
          : [];
        // @ts-ignore
        return ATTACH_PAYLOAD.concat(UPLOADED_PAYLOAD);
      },
      getCategoryIdFromServiceType(serviceType): number {
        switch (serviceType) {
          case 'Medical':
          case 'MEDI':
            return 1;
          case 'Dental':
          case 'DNTL':
            return 3;
          case 'Dependent care':
          case 'DEPC':
            return 4;
          default:
          // fall through
        }
        return 7;
      },
      getCurrentDate(): string {
        return moment()
          .format(dateFormat);
      },
      showSuccess(): void {
        this.confirmBeforeClose = false;
        this.showSubmitSuccessMessage = true;
        this.showSubmitErrorMessage = false;
        this.submitIsLoading = false;

        // GTM Event - Submit Claim
        window.dataLayer.push({
          event: 'submitClaim',
        });
      },
      showError(): void {
        this.confirmBeforeClose = false;
        this.showSubmitErrorMessage = true;
        this.showSubmitSuccessMessage = false;
        this.submitIsLoading = false;
      },
      setPayToOption(newProviderId): void {
        this.formModel.payTo = this.payToOptions.find((provider) => {
          return provider.value.toString() === newProviderId.toString();
        });
      },
      getFormatDateMMDDYYYY(dateToFormat): string {
        return moment(dateToFormat)
          .format(dateFormat);
      },
    },
    components: {
      TokenReAuth,
      StepperWrapper,
      NumberEntry,
      AttachDocuments,
      DatePicker,
      FullscreenSuccess,
      FullscreenError,
      FullscreenLoading,
    },
  });
